export function runAfterDOMLoaded(callback: () => void){
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            callback();
        });
    } else {
        callback();
    }
}

export function cookieExist(cookieName: string) {
    const regex = new RegExp('^(.*;)?\\s*' + cookieName + '\\s*=\\s*[^;]+(.*)?$');
    return !!document.cookie.match(regex);
}
